import MobileImproveSummary from './mobile-improve-summary';

export default MobileImproveSummary;
